import React from 'react';

type InformationProps = {
  ceo?: string;
  address?: string;
  support?: string;
  copy: string;
};

/**
 * @description Footer에 들어가는 회사 정보 컴포넌트
 * @property {Array<string>} info 회사 정보
 * @property {string} copy Copy Write
 */
function Information({ ceo, address, support, copy }: InformationProps) {
  return (
    <div className="information-wrapper wrapper">
      <div className="text-caption" id="information">
        {ceo && <p>{ceo}</p>}
        {address && <p>{address}</p>}
        {support && <p className="text-primary">{support}</p>}
      </div>
      <p className="text-caption" id="copywrite">
        {copy}
      </p>
    </div>
  );
}

export default Information;
